// extracted by mini-css-extract-plugin
module.exports = {"list":"List_list__wsKQt","ol":"List_ol__B5nxU","ul":"List_ul__a8gE2"};